<template>
  <ion-page>
    <ion-content class="login-bg">
      <div class="login-container">
        
        <!-- Logo -->
        <div class="logo-wrapper glass-effect">
          <img src="/assets/logo.png" alt="Logo" class="logo" />
        </div>

        <!-- Title -->
        <div class="title-section ion-text-center">
          <h1 class="main-title">Absensi QR Code</h1>
          <p class="sub-title">
            Sistem Absensi Mahasiswa Berbasis QR Code<br/>
            Prodi Informatika Fakultas Ilmu Komputer
          </p>
        </div>

        <div class="login-box glass-effect">
          <h2 class="box-title ion-text-center">MASUK KE SISTEM</h2>

          <!-- Form -->
          <div class="form-group">
            <label class="input-label">NPM / NIDN</label>
            <div class="input-wrapper">
              <ion-icon :icon="personOutline" class="input-icon"></ion-icon>
              <input v-model="username" type="text" class="custom-input" placeholder="XXX.XXX.XXX" />
            </div>
          </div>

          <div class="form-group">
            <label class="input-label">Password</label>
            <div class="input-wrapper">
              <ion-icon :icon="lockClosedOutline" class="input-icon"></ion-icon>
              <input v-model="password" type="password" class="custom-input" placeholder="999.999.999" />
            </div>
          </div>

          <!-- Options -->
          <div class="options-row">
            <label class="checkbox-container">
              <input type="checkbox" checked />
              <span class="checkmark"></span>
              Ingat Saya
            </label>
            <a href="#" class="forgot-link">Lupa Password?</a>
          </div>

          <!-- Submit Button -->
          <button class="btn-primary" @click="handleLogin">
            MASUK
          </button>
        </div>

        <!-- Footer -->
        <div class="footer-box glass-effect ion-text-center">
          Hak akses: Dosen & Mahasiswa
        </div>
        
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent, IonIcon } from '@ionic/vue';
import { ref } from 'vue';
import { personOutline, lockClosedOutline } from 'ionicons/icons';
import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

export default {
  name: 'LoginPage',
  components: {
    IonPage, IonContent, IonIcon
  },
  setup() {
    const username = ref('');
    const password = ref('');

    const handleLogin = async () => {
      const u = username.value.toLowerCase().trim();
      const p = password.value;

      if (!u || !p) {
        alert("Masukkan Username dan Password terlebih dahulu!");
        return;
      }

      // Hardcoded Admin & Dosen
      if (u === 'admin' && p === 'admin123') {
        localStorage.setItem('user_npm', 'admin');
        localStorage.setItem('user_role', 'admin');
        window.location.href = '/dosen';
        return;
      } 
      
      // Query Dosen from Firestore
      try {
        const qDosen = query(collection(db, "dosen"), where("nidn", "==", u));
        const snapDosen = await getDocs(qDosen);

        if (!snapDosen.empty) {
          const dosenData = snapDosen.docs[0].data();
          if (p === dosenData.password || p === 'dosen123') {
            localStorage.setItem('user_npm', u);
            localStorage.setItem('user_role', 'dosen');
            window.location.href = '/dosen';
            return;
          } else {
            alert("Password dosen salah!");
            return;
          }
        }
      } catch (err) {
        console.error(err);
      }

      // Query Mahasiswa from Firestore
      try {
        const q = query(collection(db, "mahasiswa"), where("npm", "==", u));
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
          const mahasiswaData = snapshot.docs[0].data();
          const validPassword = mahasiswaData.password || 'mahasiswa123';
          
          if (p === validPassword || p === '123456') {
            localStorage.setItem('user_npm', u);
            localStorage.setItem('user_role', 'mahasiswa');
            window.location.href = '/mahasiswa';
          } else {
            alert("Password mahasiswa salah!");
          }
        } else {
          alert("Username atau Password salah! Mahasiswa tidak ditemukan.");
        }
      } catch (err) {
        console.error(err);
        alert("Terjadi kesalahan jaringan.");
      }
    };

    return {
      username,
      password,
      handleLogin,
      personOutline,
      lockClosedOutline
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

* {
  font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
}

.login-bg {
  --background: #fdfaf0;
  /* subtle yellow gradient background */
  --background: linear-gradient(135deg, #fdfbf1 0%, #fff7ce 100%);
}

.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  padding: 20px;
}

.glass-effect {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
}

.logo-wrapper {
  padding: 15px;
  border-radius: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 100px;
  height: 100px;
  object-fit: contain;
}

.title-section {
  margin-bottom: 30px;
}

.main-title {
  font-weight: 700;
  font-size: 24px;
  color: #333;
  margin: 0 0 5px 0;
  letter-spacing: 1px;
}

.sub-title {
  font-size: 13px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

.login-box {
  width: 100%;
  max-width: 400px;
  border-radius: 24px;
  padding: 30px 25px;
  margin-bottom: 20px;
}

.box-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 25px;
  letter-spacing: 1px;
}

.form-group {
  margin-bottom: 20px;
}

.input-label {
  display: block;
  font-size: 13px;
  color: #555;
  margin-bottom: 8px;
  font-weight: 500;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 15px;
  color: #888;
  font-size: 18px;
}

.custom-input {
  width: 100%;
  padding: 14px 15px 14px 45px;
  border: 1.5px solid #eaeaea;
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: white;
  transition: all 0.3s ease;
}

.custom-input:focus {
  border-color: #ffd000;
  box-shadow: 0 0 0 4px rgba(255, 208, 0, 0.15);
}

.options-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  font-size: 12px;
}

.checkbox-container {
  display: flex;
  align-items: center;
  color: #555;
  cursor: pointer;
  position: relative;
  padding-left: 25px;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #fff;
  border: 1.5px solid #ccc;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.checkbox-container:hover input ~ .checkmark {
  background-color: #f4f4f4;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: #ffd000;
  border-color: #ffd000;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid #333;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.forgot-link {
  color: #555;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px solid transparent;
  transition: all 0.3s ease;
}

.forgot-link:hover {
  color: #ffd000;
  border-bottom: 1px solid #ffd000;
}

.btn-primary {
  width: 100%;
  padding: 16px;
  background: #222;
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.btn-primary:hover {
  background: #ffd000;
  color: #222;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 208, 0, 0.3);
}

.btn-primary:active {
  transform: translateY(0);
}

.footer-box {
  width: 100%;
  max-width: 400px;
  padding: 15px;
  border-radius: 12px;
  font-size: 12px;
  color: #666;
  font-weight: 500;
}
</style>
